const HtmlTextField = ({ fieldPath, fieldProps, value = "-" }) => {
  return <pre dangerouslySetInnerHTML={{ __html: value }} />
}

export default HtmlTextField
